import { getStore, removeStore, setStore } from "@/util/store";
import { foodmacMacruntimeWorkorderFindworkorderstatisticlist } from "@/api/hb-work-order/common";

const curveAnalysis = {
    state: {
      // 曲线分析选择数据
      curveAnalysisSelectParams:{},
      // 曲线分析数据
      curveAnalysisList: []
    },
    actions: {
       setCurveAnalysisList({ commit }, data){
        return new Promise((resolve, reject) => {
            foodmacMacruntimeWorkorderFindworkorderstatisticlist(data)
              .then((response) => {
                let dataRes = response.data.data;
                console.log(dataRes);
                dataRes = response.data.data.map(ele =>{
                    ele.SteamPres = JSON.parse(ele.workOrderStatistic).SteamPres
                    ele.CookTemp = JSON.parse(ele.workOrderStatistic).CookTemp
                    return ele
                })
                commit("SET_CURVEANALYSISLIST", dataRes);
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          });
    
      }
    },
    mutations: {
      SET_CURVEANALYSISSELECTPARAMS:(state, curveAnalysisSelectParams) => {
        state.curveAnalysisSelectParams = curveAnalysisSelectParams
      },
      SET_CURVEANALYSISLIST: (state, curveAnalysisList) => {   
        state.curveAnalysisList = curveAnalysisList
      }
    }
  };
  export default curveAnalysis